<template>
  <div>
    <FormClientes :parametros="parametros" v-if="!parametros.form_distribuidores"></FormClientes>
    <FormDistribuidores :parametros="parametros" v-if="parametros.form_distribuidores"></FormDistribuidores>
  </div>
</template>

<script>

// Dependencies
import '@fortawesome/fontawesome-free/css/all.min.css';

// Child components
import FormClientes from './components/FormClientes.vue';
import FormDistribuidores from './components/FormDistribuidores.vue';


export default {
  name: 'App',
  components: {
    FormClientes,
    FormDistribuidores
  },
  computed: {
    parametros(){
      return parametros; // definición externa en var js
    }
  }
}
</script>

